import React from "react";

import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import { Link } from "react-router-dom";

export default class ManualTree extends React.Component {
  getChildren = (itemId) => {
    let children = [];
    for (let id in this.props.items) {
      let item = this.props.items[id];
      if (item.node === itemId) children.push(item);
    }
    return children;
  };

  render() {
    const renderTree = (item) => (
      <TreeItem
        onClick={(e) => e.preventDefault()}
        key={item.id}
        nodeId={String(item.id)}
        label={
          <>
            <Link className="d-block py-1 text-dark" to={`/manual/${item.id}/`}>
              {item.label}
            </Link>
          </>
        }
        className="my-2"
        onLabelClick={(e) => e.preventDefault()}
      >
        {this.getChildren(item.id).map((item) => renderTree(item))}
      </TreeItem>
    );

    return (
      <>
        <TreeView
          defaultCollapseIcon={<i className="fa fa-angle-down"></i>}
          defaultExpandIcon={<i className="fa fa-angle-right"></i>}
          expanded={this.props.expanded}
          selected={this.props.selected}
          onNodeToggle={this.props.onNodeToggle}
          onNodeSelect={this.props.onNodeSelect}
        >
          {Object.entries(this.props.items).map(([id, item]) =>
            item.level === 0 ? renderTree(item) : null
          )}
        </TreeView>
      </>
    );
  }
}
